'use client';

import { Box, Text } from '@chakra-ui/react';
import { StaticPage } from '../../types';
import CustomPortableText from '../CustomPortableText/CustomPortableText';
import { useLocale } from 'next-intl';

type Props = {
	data: StaticPage;
};

const SanityStaticPage = ({ data }: Props) => {
	const locale = useLocale() as 'th' | 'en';
	const content = data.content?.[locale];

	return (
		<Box
			maxW={'3xl'}
			mx={'auto'}
		>
			{content
				? <CustomPortableText value={content} />
				: <Text color={'gray.500'}>No content available in this language.</Text>}
		</Box>
	);
};

export default SanityStaticPage;